import { useMutation } from 'react-query'

import { AxiosError } from 'axios'
import * as GenericError from 'entities/GenericError'
import { useAnswers } from 'providers/AnswersProvider'
import { usePatient } from 'providers/PatientProvider'
import api from 'services/api'
import { PostOptins } from 'services/api/ana'
import sentryService from 'services/sentry'

import ServerError from '../@types/ServerError'

export const usePostOptins = () => {
  const answers = useAnswers()
  const patient = usePatient()

  return useMutation(
    (optins: PostOptins) => {
      return api.ana.postOptins(optins)
    },
    {
      onError: (error: AxiosError<ServerError>) => {
        sentryService.captureLegalDocumentsError({ error, code: answers.code, clinic: patient?.data?.clinic })
      },
      retry: (failureCount, error) => failureCount <= 3 && GenericError.isNetworkError(error),
    }
  )
}
